import { render } from "./UiInput.vue?vue&type=template&id=2ff535ca&scoped=true&lang=pug"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"

import "./UiInput.vue?vue&type=style&index=0&id=2ff535ca&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff535ca"]])

export default __exports__